<template>
  <div
    v-show="isShown"
    class="triplabot-icon-container"
    :class="[
      {
        'is-mobile': isMobile,
        'is-minimizer-left': getIconMessagePosition === 'top'
      }
    ]"
  >
    <span v-if="showEffect" class="icon-pulse-effect" />
    <div class="triplabot-icon-circle" @click="iconClick">
      <img class="tripla-icon" :src="conciergeIcon" alt="Icon image" />
    </div>
    <i class="triplabot-minimizer" @click.stop.prevent="minimize"></i>
  </div>
</template>

<script>
import { isMobile } from 'Utilities'
import { useAppStore } from 'Store/app'
import { mapState } from 'pinia'
import { useSettingsStore } from 'Store/settings'
import { useColorsStore } from 'Store/colors'

export default {
  name: 'ChatIcon',

  setup() {
    const appStore = useAppStore()
    const colorsStore = useColorsStore()

    return { appStore, colorsStore }
  },

  props: {
    toggleChat: { type: Function, required: true }
  },

  data() {
    return {
      isMobile: isMobile()
    }
  },

  computed: {
    ...mapState(useSettingsStore, ['getIconMessagePosition']),

    conciergeIcon() {
      return this.appStore.imageURL
    },

    showEffect() {
      return false
    },
    isShown() {
      return this.appStore.imageReady
    }
  },

  created() {
    window.addEventListener('message', this.handlePostMessage)
  },

  beforeDestroy() {
    window.removeEventListener('message', this.handlePostMessage)
  },

  methods: {
    minimize() {
      this.$emit('minimize')
    },

    iconClick() {
      this.toggleChat()
      this.$gtag.recordEventChatOpen('Chatbot icon', null)
    },

    handlePostMessage(message) {
      const data = message.data || {}
      if (data.action === 'booking-widget-opened') {
        this.appStore.setIsOnBookingWidget(true)
      } else if (data.action === 'close') {
        this.appStore.setIsOnBookingWidget(false)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.triplabot-icon-container {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 50% 0 50% 50%;

  &:hover,
  &.is-mobile {
    .triplabot-minimizer {
      display: block;
    }
  }

  & .triplabot-minimizer {
    position: absolute;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    background: #fff;
    right: 10px;
    top: -6px;
    width: 20px;
    height: 20px;
    transform: translate(50%, -50%);
    display: none;

    &:hover {
      cursor: pointer;
    }

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 12px;
      height: 2px;
      background: #000;
    }
  }

  &.is-minimizer-left {
    border-radius: 0 50% 50% 50%;

    & .triplabot-minimizer {
      left: -6px;
      top: 6px;
      right: unset;
      transform: translate(-50%, -50%);
    }
  }
}

.triplabot-icon-circle {
  display: inline-flex;
  border-radius: 50%;
  width: 100%;
  height: 100%;
  border: 2px solid var(--tripla-theme-color);
}

.triplabot-icon-container .icon-pulse-effect {
  display: inline-block;
  margin: auto;
  position: absolute;
  content: '';
  width: 100%;
  height: 100%;
  border-radius: 50%;
  z-index: -20;
  animation: pulse-effect 2000ms linear infinite;
  background: var(--tripla-theme-color);
}

.triplabot-icon-container .tripla-icon {
  width: 100%;
  height: 100%;
  border-radius: 50%;

  &.v2 {
    filter: drop-shadow(-1px -1px 4px rgba(0, 0, 0, 0.1))
      drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.15));
  }
}

@keyframes pulse-effect {
  0% {
    transform: scale(1);
    filter: alpha(opacity=50);
    opacity: 0.5;
  }
  30% {
    transform: scale(1);
    filter: alpha(opacity=50);
    opacity: 0.5;
  }
  100% {
    transform: scale(2);
    filter: alpha(opacity=0);
    opacity: 0;
  }
}
</style>
